import { AlertTriangle } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { JobPostingsList } from '@/components/job-postings/JobPostingsList';
import { useApplicationStore } from '@/store/applicationStore';
import { useAuthStore } from '@/store/authStore';

export function JobListingsPage() {
  const { t } = useTranslation();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const checkExistingApplications = useApplicationStore((state) => state.checkExistingApplications);

  const [activeAppCount, setActiveAppCount] = useState(0);
  const isLimitReached = isAuthenticated && activeAppCount >= 5;

  useEffect(() => {
    if (!isAuthenticated) return;
    checkExistingApplications()
      .then((apps) => {
        setActiveAppCount(apps.filter((a) => a.status !== 'rejected').length);
      })
      .catch(() => {
        /* ignore */
      });
  }, [isAuthenticated, checkExistingApplications]);

  return (
    <div className='max-w-6xl mx-auto px-4 py-6 md:py-8'>
      <div className='mb-5'>
        <h1 className='text-3xl md:text-4xl font-bold text-gray-900 mb-2'>{t('jobListings.title')}</h1>
        <p className='text-gray-600 text-lg'>{t('jobListings.subtitle')}</p>
      </div>

      {isLimitReached && (
        <div className='mb-6 rounded-lg border border-amber-200 bg-amber-50 p-4'>
          <div className='flex items-center gap-2 text-amber-700'>
            <AlertTriangle className='h-5 w-5 shrink-0' />
            <span className='font-semibold'>{t('jobPostings.applicationLimit.banner')}</span>
          </div>
          <p className='mt-1 text-sm text-amber-600 ml-7'>
            <Link to='/dashboard' className='font-medium text-primary hover:text-primary-dark underline'>
              {t('jobPostings.applicationLimit.bannerLink')}
            </Link>
          </p>
        </div>
      )}

      <JobPostingsList />
    </div>
  );
}
